<template>
  <AppDataTable design="new" density="dense" :columns="columns" :rows="rows" :loading="loading" min-width="1200px" clickable @row-click="$emit('open', $event.row.id)">
    <template #cell-client="{ row }"><AppTableText :text="row.client_name" /></template>
    <template #cell-group="{ row }"><AppTableText :text="row.group && row.group.name" /></template>
    <template #cell-arrival="{ row }"><AppTableText :text="daysLabel(row.days_to_arrival)" :tooltip="row.arrival_date ? `Arrival: ${dateOnly(row.arrival_date)}` : ''" /></template>
    <template #cell-channels="{ row }">
      <div class="insurance-client-table__channels">
        <span v-for="channel in ['email', 'whatsapp']" :key="channel" v-tooltip="tip(channelHint(channel, row[`${channel}_status`], row[`${channel}_reason`]))" class="insurance-client-table__channel" :class="`insurance-client-table__channel--${statusTone(row[`${channel}_status`])}`" tabindex="0" :aria-label="channelHint(channel, row[`${channel}_status`], row[`${channel}_reason`])" @keydown.enter.stop @keydown.space.stop>
          <i class="pi" :class="channel === 'email' ? 'pi-envelope' : 'pi-whatsapp'" aria-hidden="true" />
        </span>
      </div>
    </template>
    <template #cell-language="{ row }"><span class="ui-cell-inline"><AppTableText :text="row.language ? row.language.toUpperCase() : ''" :tooltip="row.language ? languageLabel(row.language, row.language_source) : ''" /><AppStatusBadge v-if="row.language_fallback" design="new" compact tone="amber" label="In English" /></span></template>
    <template #cell-checked="{ row }"><AppTableText :text="dateTime(row.last_checked_at)" /></template>
  </AppDataTable>
</template>

<script>
import AppTableText from '@/components/AppTableText.vue'
import { channelHint, dateOnly, dateTime, daysLabel, languageLabel, statusTone } from './model'

export default {
  name: 'InsuranceUpdateClientTable',
  components: { AppTableText },
  props: {
    rows: { type: Array, default: () => [] },
    columns: { type: Array, required: true },
    loading: Boolean
  },
  methods: {
    channelHint,
    dateOnly,
    dateTime,
    daysLabel,
    languageLabel,
    statusTone,
    tip(content) { return { content, placement: 'top', offset: 8, classes: 'tooltip--new', trigger: 'hover focus' } }
  }
}
</script>

<style scoped lang="scss">
.insurance-client-table__channels { display: flex; gap: $ui-space-8; }
.insurance-client-table__channel { display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border-radius: 50%; }
.insurance-client-table__channel .pi { color: #fff; font-size: 16px; }
.insurance-client-table__channel--green { background: $ui-green; }
.insurance-client-table__channel--blue { background: $ui-blue; }
.insurance-client-table__channel--amber { background: $ui-amber; }
.insurance-client-table__channel--red { background: $ui-red; }
.insurance-client-table__channel--neutral { background: $ui-muted; }
.insurance-client-table__channel:focus-visible { outline: 2px solid $ui-blue; outline-offset: 2px; }
</style>
